import React, { SyntheticEvent } from "react"
import { useTranslation } from "react-i18next";

//MUI
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";

// Custom
import InfoPaneActionButton from "./InfoPaneActionButton";

type InfoPaneGPXActionButtonProps = {
  onClick: (evt: SyntheticEvent) => void;
}

const InfoPaneGPXActionButton = (props: InfoPaneGPXActionButtonProps) => {

  const { onClick } = props;

  return (
    <InfoPaneActionButton
      icon={
        <FileDownloadOutlinedIcon
          sx={{ transform: "scale(0.8)" }}
          color="primary" fontSize="large"
        />
      }
      onClick={onClick}
      title_ttoken="map:route.buttons.download_gpx"
    />
  );
}

export default InfoPaneGPXActionButton;
